// The Main Site Object
window.Site = {

    header     : document.querySelector('.header'),
    hero       : document.querySelector('.hero-container'),
    menuButton : document.querySelector('.menu-button'),
    blocks     : document.querySelectorAll('.block'),
    blockVideo : document.querySelectorAll('.block-video-content'),

    // Init Function
    liftoff : () => {
        Site.shrinkHeaderOnScroll()
        Site.toggleMenuOnMobile()
        Site.fadeSectionsIn()
        Site.pauseOtherVideosWhenOneIsPlaying()
        Site.pauseVideoWhenIsOutOfWindow()
    },

    shrinkHeaderOnScroll : () => {

        // 1. Define the Callback (What happens when visibility changes)
        const callback = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    document.body.classList.remove('small-header')
                } else {
                    document.body.classList.add('small-header')
                }
            });
        };

        // 2. Define Options (The "When" and "Where")
        const options = {
            root       : null,         // Defaults to the browser viewport
            rootMargin : '0px',  // Margin around the root (like CSS margin)
            threshold  : 0.15      // Triggers when 10% of the element is visible
        };

        // 3. Initialize and Start Observing
        const observer = new IntersectionObserver(callback, options);

        // Target specific elements
        observer.observe(Site.hero)

    },

    toggleMenuOnMobile : () => {
        Site.menuButton.addEventListener('click' , () => {
            document.body.classList.toggle('mobile-menu-is-open')
        })

        document.body.addEventListener('click' , (event) => {
            if (event.target.classList.contains('menu-button') || event.target.classList.contains('header-menu-item')) return;
            document.body.classList.remove('mobile-menu-is-open')
        })

    },

    fadeSectionsIn : () => {
        
        const options = {
            root       : null,
            rootMargin : '0px 0px -150px 0px',
            threshold  : 0
        };

        const callback = (entries, observer) => {
            entries.forEach(entry => {

                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                    observer.unobserve(entry.target);
                }
            });
        };

        const observer = new IntersectionObserver(callback, options);

        Site.blocks.forEach(block => {
            observer.observe(block);
        })
    },

    pauseOtherVideosWhenOneIsPlaying : () => {

        Site.blockVideo.forEach(video => {
            video.addEventListener('play' , () => {
                Site.blockVideo.forEach(v => {
                    if (v == video) return;
                    v.pause()
                })
            })
        })

    },

    pauseVideoWhenIsOutOfWindow : () => {

        const videoObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.muted = false;
                } else {
                    entry.target.muted = true;
                }
            });
        },
        {
            root       : null,
            rootMargin : '0px',
            threshold  : 0.5
        });


        Site.blockVideo.forEach(video => {
            videoObserver.observe(video);
        })

    }

}

// Launch The Script
Site.liftoff()